export default "__VITE_ASSET__C006pnsg__"